export const wrapComponent = (Component, wrappers) =>
  wrappers.reduce((result, wrapper) => wrapper(result), Component);
